<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import MaterialBlock from '../MaterialBlock.vue'
import { ArrowRightIcon } from '@heroicons/vue/20/solid'
import GenderBlock from '../GenderBlock.vue'
import Button from '@/Components/Button.vue'
import { AttributeMenuBlock, GenderMenuBlock, MaterialMenuBlock, NavbarMenu } from '@interfaces/menu.interface'
import AttributeBlock from '../AttributeBlock.vue'

const props = defineProps<{
    menu: NavbarMenu,
}>()

const attributeBlocks = props.menu.blocks.filter((block) => block.type === 'attribute') as AttributeMenuBlock[]
const materialBlock = props.menu.blocks.find((block) => block.type === 'material') as MaterialMenuBlock
const genderBlock = props.menu.blocks.find((block) => block.type === 'gender') as GenderMenuBlock
</script>

<template>
    <div>
        <Button
            :as="Link"
            :href="menu.url"
            color="primary"
            color-variant="plain"
            size="sm"
            class="mb-6 group"
        >
            {{ $t('components.menu.catalog.sections.bracelets.link') }}
            <ArrowRightIcon class="w-4 h-4 ml-1 transition-transform duration-300 transform group-hover:translate-x-0.5" />
        </Button>

        <div class="grid grid-cols-3 gap-8">
            <div class="space-y-8">
                <AttributeBlock
                    v-for="block in attributeBlocks"
                    :key="block.code"
                    :block="block"
                />

                <GenderBlock
                    v-if="genderBlock"
                    :block="genderBlock"
                />
            </div>

            <MaterialBlock
                v-if="materialBlock"
                :block="materialBlock"
            />

            <div>
                <div class="relative z-10 overflow-hidden rounded-xl group aspect-w-2 aspect-h-1 sm:aspect-w-2">
                    <picture>
                        <source
                            data-srcset="/images/sections/categories/bracelets.webp"
                            type="image/webp"
                        >
                        <source
                            data-srcset="/images/sections/categories/bracelets.jpg"
                            type="image/jpeg"
                        >

                        <img
                            data-src="/images/sections/categories/bracelets.jpg"
                            :alt="$t('components.menu.catalog.sections.bracelets.kabbalah-bracelets')"
                            class="inset-0 object-cover object-top w-full h-full transition-transform duration-200 ease-in-out scale-150 lazyload group-hover:scale-110"
                        >
                    </picture>
                    <div
                        aria-hidden="true"
                        class="opacity-50 bg-gradient-to-b from-transparent to-black"
                    ></div>

                    <div class="absolute inset-0 flex items-end p-4">
                        <div>
                            <p class="font-medium text-white text-p1">
                                <Link :href="route('catalog', 'kabbalah')">
                                <span class="absolute inset-0"></span>
                                {{ $t('components.menu.catalog.sections.bracelets.kabbalah-bracelets') }}
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
